@if (vm$ | async; as vm) {
  <div class="button-wrapper">
    @if (vm.actions.length) {
      <div class="survey-actions js-survey-actions">
        @for (action of vm.actions; track action.action) {
          <div class="survey-actions__action">
            <jui-button
              class="action-{{ action.action }}"
              size="xl"
              title="{{ action.label }}"
              expand
              [display]="action.buttonDisplay"
              [color]="action.buttonVariant"
              [disabled]="action.disabled"
              (click)="executeAction(action)"
              [attr.data-qa]="action.qaAttribute"
              >
              {{ action.label }}
            </jui-button>
          </div>
        }
      </div>
    }
    @if (vm.hasReset) {
      <div class="survey-actions survey-actions--helper">
        <div class="survey-actions__action survey-actions__action--reset">
          <jui-button
            class="action-reset"
            size="xl"
            title="Reset"
            expand
            color="low"
            (click)="resetCards()"
            [attr.data-qa]="'resetButton'"
            >
            Reset
          </jui-button>
        </div>
      </div>
    }
  </div>
}
